var FileSaver_min = {exports: {}};

export { FileSaver_min as __module };
//# sourceMappingURL=FileSaver.min2.js.map
